var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-textarea',{attrs:{"value":_vm.value,"auto-grow":"","counter":"1000","label":"Observação","maxlength":"1000","outlined":"","rows":_vm.rows},on:{"input":function($event){return _vm.$emit('input', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }